export const DAY_MS = 24 * 60 * 60 * 1000;
